(function () {
  function init(root) {
    if (root.dataset.supportReady) return;
    root.dataset.supportReady = 'true';
    root.classList.add('is-ready');
    var form = root.querySelector('[data-support-search]');
    var input = root.querySelector('[data-support-query]');
    var clear = root.querySelector('[data-support-clear]');
    var cards = Array.from(root.querySelectorAll('[data-support-topic]'));
    var status = root.querySelector('[data-support-count]');
    var empty = root.querySelector('[data-support-empty]');
    function filter() {
      var query = input.value.trim().toLowerCase();
      var words = query.split(/\s+/).filter(Boolean);
      var count = 0;
      cards.forEach(function (card) {
        var text = (card.textContent + ' ' + card.dataset.searchWords).toLowerCase();
        card.hidden = !words.every(function (word) { return text.includes(word); });
        if (!card.hidden) count++;
      });
      clear.hidden = !input.value;
      empty.hidden = count !== 0;
      status.textContent = count + (count === 1 ? ' topic' : ' topics') + (query ? ' found' : ' to explore');
    }
    function reset() { input.value = ''; filter(); input.focus(); }
    if (input && form) {
      input.addEventListener('input', filter);
      input.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); reset(); } });
      clear.addEventListener('click', reset);
      root.querySelector('[data-support-reset]').addEventListener('click', reset);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        filter();
        var first = cards.find(function (card) { return !card.hidden; });
        if (first) first.focus();
      });
      filter();
    }
    var result = root.querySelector('[data-support-form-status]');
    var contact = root.querySelector('.support-hub__form');
    var sending = root.querySelector('[data-support-send-status]');
    var sendingTimer;
    if (contact && sending) {
      contact.addEventListener('submit', function () {
        clearTimeout(sendingTimer);
        if (result) result.hidden = true;
        sending.hidden = false;
        var message = sending.querySelector('[data-support-send-message]');
        message.textContent = sending.dataset.pendingText;
        sendingTimer = setTimeout(function () {
          message.textContent = sending.dataset.delayedText;
        }, 15000);
      }, true);
    }
    if (result) result.focus();
  }
  function initAll(scope) { scope.querySelectorAll('[data-support-hub]').forEach(init); }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
